import React, {useState} from "react"
import {SmartCaptcha} from "@yandex/smart-captcha"
import {Button, Input, notification} from "antd"
import {useStore} from "@ui/stores"
import {t} from "@ui/common/intl"
import Loader from "@ui/components/common/Loader"

const Login = (): React.ReactElement => {
  const [loading, setLoading] = useState(false)
	const [username, setUsername] = useState("")
	const [password, setPassword] = useState("")
  const [token, setToken] = useState("")
  const [resetCaptcha, setResetCaptcha] = useState(0)
  const [sent, setSent] = useState(false)

  const [notify, contextHolder] = notification.useNotification()
  const {user} = useStore()

  const notifyError = (message: string) => {
    notify.error({
        message,
        duration: 5,
        placement: 'top',
        className: "error-notification"
      })
  }

  const isEmail = (email: string) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)

	const handleLogin = async () => {
    setLoading(true)
    try {
      await user.login({username, password})
    } catch (error: any) {
      let message = t("login.common.error")
      if (error.response?.status === 401) {
        const {error_description} = error?.response?.data
        if (error_description === "Password expired") {
          message = t("login.password.expired")
          setSent(false)
        } else {
          message = t("login.incorrect.auth.data")
        }
      }
      notifyError(message)
    } finally {
      setLoading(false)
    }
	}

  const handleSentOTP = async () => {
    setLoading(true)
    try {
      await user.sendOTP({email: username, smartToken: token})
      setSent(true)
    } catch (error: any) {
      setResetCaptcha((prev) => prev + 1)
      setToken("")
      notifyError(t("send.otp.error"))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login">
      {contextHolder}
      <div className="welcome-text">
        <div className="large-header-text">{t("hello.text")}</div>
        <div className="primary-text">{t("login.enter.text")}</div>
      </div>
      <div className="data" onKeyDown={(e) => e.key === "Enter" && handleLogin()}>
        {loading
          ? <Loader />
          : <>
            <Input
              placeholder={t("login.placeholder")}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="input"
            />
            {sent
              ? <Input.Password
                type="password"
                placeholder={t("password.placeholder")}
                onChange={(e) => setPassword(e.target.value)}
                className="input"
              />
              : <SmartCaptcha
                key={resetCaptcha}
                sitekey="ysc1_j36C6jcNVcd4dks66IBQAyFOT1gDRAQejlIeNc4uc95cd426"
                onSuccess={setToken}
              />
            }
          </>
        }
      </div>
      <Button
        className="button-primary"
        onClick={sent ? handleLogin : handleSentOTP}
        disabled={loading || !username || !isEmail(username.trim()) || !(token || sent) || !(password || !sent)}
      >
        {t(`button.${sent ? "login" : "sent.otp"}`)}
      </Button>
    </div>
  )
}

export default Login
